module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Analogico-HF-3.a799afcd.png";